import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import * as PhosphorIcons from "@phosphor-icons/react";

/**
 * Stage "share_link": mostra il link cliente generato dopo purchase in modalità condivisa.
 */
export default function ShareLinkStage({ shareLinkInfo, onCopy, onClose }) {
  return (
    <div className="space-y-4" data-testid="share-link-panel">
      <div className="flex items-center gap-3 p-3 bg-emerald-50 border border-emerald-200 rounded-md">
        <div className="h-10 w-10 rounded-full bg-emerald-500 text-white flex items-center justify-center flex-shrink-0">
          <PhosphorIcons.CheckCircle size={22} weight="fill" />
        </div>
        <div>
          <div className="font-semibold text-emerald-900 text-sm">Pratica creata correttamente</div>
          <div className="text-xs text-emerald-800 mt-0.5">
            Condividi il link qui sotto con {shareLinkInfo.client_name || "il cliente finale"} per completare il
            pagamento.
          </div>
        </div>
      </div>

      <div>
        <Label className="text-xs uppercase tracking-wider text-purple-800 font-bold">Link pagamento cliente</Label>
        <div className="flex items-stretch gap-2 mt-1.5">
          <Input
            readOnly
            value={shareLinkInfo.url}
            onFocus={(e) => e.target.select()}
            className="font-mono text-xs bg-slate-50"
            data-testid="share-link-input"
          />
          <Button type="button" onClick={onCopy} className="ht-gradient border-0 shrink-0" data-testid="share-link-copy-btn">
            <PhosphorIcons.Copy size={16} weight="bold" className="mr-1.5" />
            Copia
          </Button>
        </div>
        <div className="text-[11px] text-muted-foreground mt-1.5">
          💡 Suggerimento: puoi inviarlo via WhatsApp, email o SMS al cliente.
        </div>
      </div>

      {shareLinkInfo.client_email && (
        <div className="text-xs text-muted-foreground">
          Email cliente registrata: <span className="font-mono">{shareLinkInfo.client_email}</span>
        </div>
      )}

      <div className="flex justify-between items-center gap-2 pt-3 border-t">
        <Button
          type="button"
          variant="ghost"
          onClick={() => window.open(shareLinkInfo.url, "_blank")}
          data-testid="share-link-open-btn"
        >
          <PhosphorIcons.ArrowSquareOut size={14} className="mr-1.5" />
          Anteprima pagamento
        </Button>
        <Button type="button" onClick={onClose} className="ht-gradient border-0" data-testid="share-link-done-btn">
          Fatto
        </Button>
      </div>
    </div>
  );
}
